/**
 * Description: 字典type
 * xxxx: {type: '', name: ''},
 */
import SJ from './consts/SJ'
import SYRK from './consts/SYRK'
import BZDZ from './consts/BZDZ'
import SYDW from './consts/SYDW'
import SYFW from './consts/SYFW'

let DicConst = {
  SJ,
  SYRK,
  BZDZ,
  SYDW,
  SYFW,
}

export default DicConst
